import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useMutation } from '@tanstack/react-query';

import { vehicleService } from '../../../../application/VehicleService';
import { Route } from '../../../../domain/route/Route';
import { useErrorMiddleware } from '../../../../hooks/useErrorMiddleware';
import { useShowSnackbarMessage } from '../../../../hooks/useShowSnackbarMessage';

type UseDeleteAccountResponseProps = ServiceResponse<() => void, Route>;

// Hooks act as 'Adapter' layer.
export const useDeleteAccount = (): UseDeleteAccountResponseProps => {
  const { sessionExpiredLogout } = useErrorMiddleware();
  const { showSnackbarMessage } = useShowSnackbarMessage();

  const { isLoading, isError, isSuccess, mutate } = useMutation<void, unknown, void>(
    () => vehicleService.deleteAccount(),
    {
      onError: (err: any) => {
        console.info(`Delete Account Error:`, err);

        if (err?.response?.status === 401) {
          sessionExpiredLogout();
          return;
        }
        showSnackbarMessage({
          messageIntlId: `infoerror.${err?.response?.data?.messageId ?? `network_error`}`,
        });
      },
    }
  );

  return {
    run: mutate,
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
  };
};
